import { connect } from 'react-redux';
import { ApplicationState } from '../../../../store';
import ConsentsSectionStart from './index';
import { SectionStatus } from '../../../sections/types';
import { IProps } from '.';

const mapStateToProps = (state: ApplicationState): IProps => {
  const personalStarted = state.student.offer.isPISectionStarted;
  const historyStarted = state.student.offer.isHSectionStarted;
  const financeStarted = state.student.financials.isSectionStarted;

  const personalComplete = state.student.offer.isPISectionComplete;
  const historyComplete = state.student.offer.isHSectionComplete;
  const financeComplete = state.student.financials.isSectionComplete;

  return {
    warning: state.student.config.Checklist.Consents.SectionStart.warning,
    personalInfoStatus: personalComplete
      ? SectionStatus.complete
      : personalStarted
        ? SectionStatus.incomplete
        : SectionStatus.empty,
    historyStatus: historyComplete
      ? SectionStatus.complete
      : historyStarted
        ? SectionStatus.incomplete
        : SectionStatus.empty,
    financeStatus: financeComplete
      ? SectionStatus.complete
      : financeStarted
        ? SectionStatus.incomplete
        : SectionStatus.empty,
  };
};
export default connect(mapStateToProps)(ConsentsSectionStart);
